import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './rtl.css';
import './i18n';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Suppress benign ResizeObserver notifications from triggering webpack error overlay
const resizeObserverLoopErrRe = /^[^(ResizeObserver loop)]*ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
const originalOnError = window.onerror;
window.onerror = function (message, ...args) {
  if (typeof message === 'string' && resizeObserverLoopErrRe.test(message)) {
    return true; // Suppress the error
  }
  if (originalOnError) {
    return originalOnError(message, ...args);
  }
  return false;
};

window.addEventListener('error', (e) => {
  if (e?.message && resizeObserverLoopErrRe.test(e.message)) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Only enable service worker in production builds.
if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register();
} else {
  serviceWorkerRegistration.unregister();
}
